import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { CalAuthGuard } from './auth/cal-guard.guard';
import { RoleAuthGuard } from './auth/role.guard';
import { DataconsoleComponent } from './features/dataconsole/dataconsole.component';
import { InvalidPermissionsComponent } from './invalid-permissions/invalid-permissions.component';
import { InternalErrorComponent } from './internal-error/internal-error.component';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import("./features/dashboardhome/home.module").then(x => x.DashobardHomeModule),
    canActivate: [CalAuthGuard]
  },
  {
    path: 'ACD',
    loadChildren: () => import('./features/acd/module/acd.routing.module').then(x => x.ACDRoutingModule),
    canActivate: [CalAuthGuard]
  },
  {
    path: 'invalid-permission',
    component: InvalidPermissionsComponent
  },
  {
    path: 'Reporting-Dashboard',
    loadChildren: () => import('./features/reportingdashboard/module/reporting-dashboard.routing.module').then(x => x.ReportingDashboardRoutingModule),
    canActivate: [CalAuthGuard]
  },
  {
    path: 'user-manager',
    loadChildren: () => import("./features/user-manager/user-manager-routing.module").then(x => x.UserManagerRoutingModule),
    canActivate: [CalAuthGuard, RoleAuthGuard],
    data: {
      roles: ['SPECIALIST']
    }
  },
  {
    path: 'DataConsole',
    component: DataconsoleComponent,
    canActivate: [CalAuthGuard]
  },
  {
    path: 'internal-error',
    component:InternalErrorComponent,
    canActivate: [CalAuthGuard]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes
    , {
      initialNavigation: 'enabledBlocking',
      useHash: true,
    }
  )],
  exports: [RouterModule]
})



export class AppRoutingModule {
}